import { Vehicle } from '../../vehicle/models/vehicle.model';
import { VehicleChecksAreas } from '../../workshop/models/vehiclecheckarea.model';
import { VehicleSeverity } from '../../workshop/models/vehicleseverity.model';
import { Fitter } from '../../fitter/models/fitter.model';

export class WorkshopDefect {
  id: number = -1;

  vehicle: Vehicle = new Vehicle();
  vehicleId: number = -1;

  vehicleCheckArea: VehicleChecksAreas = new VehicleChecksAreas();
  vehicleCheckAreaId: number = -1;

  severity: VehicleSeverity = new VehicleSeverity();
  severityId: number = -1;

  description: string = '';

  // 'manual' | 'walkaround'
  source: string = 'manual';
  driverCheckReportId: number = null;

  // Legacy single-fitter fields, superseded by fitterAssignments below.
  fitter: Fitter = new Fitter();
  fitterId: number = -1;

  fitterAssignments: any[] = [];
  parts: any[] = [];

  // 'open' | 'assigned' | 'in_progress' | 'complete'
  status: string = 'open';

  notes: string = '';

  invoiceId: number = null;

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
